import { parse, stringify } from 'qs';
import { get, omitBy, pick, pickBy, reduce } from 'lodash';
import { getPartySearchValidParams } from '../partiesHelper';
import messages from '../translationMessages';
import { hyphenateUrlComponents } from './boats';
import { hyphenateUrlComponents as enginesHyphenateUrlComponents } from './engines';
import { getCurrentRoutes as rts, formatMessage as t } from '../language';

// TPP-25: In order to fix the special characters issue in the URL, the "hyphenateUrlComponents" function is used,
// the only issue is that it duplicates the hyphens found in the string, so we need to get rid of them before.
export const getPartyBrandedSRP = (party, customBrandedSRP = false, isOemModel, make, salesRep = null) => {
  const normalizedName = party.normalizedName ? hyphenateUrlComponents(party.normalizedName.replace(/-/g, ' ')) : party.normalizedName;
  let urlParts = [];
  let salesRepUrl = '';

  if (customBrandedSRP && isOemModel) {
    const conditionUrl = `${t(messages.search.condition)}-${t(messages.conditionFacet.new)}`;
    const makeUrl = `${t(messages.search.make)}-${make.toLowerCase()}`;
    return `${rts().SEARCH_URL_ROOT}${[conditionUrl, makeUrl].join('/')}/`;
  }

  if (normalizedName) {
    urlParts.push(normalizedName);
  }
  urlParts.push(party.id);
  if (salesRep) {
    salesRepUrl = `${t(messages.search.salesRep)}-${salesRep.normalizedName}-${salesRep.id}/`;
  }
  return customBrandedSRP ? `${rts().CUSTOM_BRANDED_SEARCH_URL_ROOT}${urlParts.join('-')}/${salesRepUrl}` : `${rts().BRANDED_SEARCH_URL_ROOT}${urlParts.join('-')}/${salesRepUrl}`;
};

export const getPartyEgninesBrandedSRP = party => {
  const normalizedName = party.normalizedName ? enginesHyphenateUrlComponents(party.normalizedName.replace(/-/g, ' ')) : party.normalizedName;
  let urlParts = [];
  if (normalizedName) {
    urlParts.push(normalizedName);
  }
  urlParts.push(party.id);
  return `${rts().ENGINES_BRANDED_SEARCH_URL_ROOT}${urlParts.join('-')}/`;
};

export const getPartySearchParams = ({ location }) => {
  const validQueryParams = getPartySearchValidParams().filter(({ query }) => query);
  const rawParams = parse(get(location, 'search', '').slice(1));
  const filteredParams = pick(rawParams,
    validQueryParams.map(({ translateParamKey }) => t(get(messages, translateParamKey)))
  );

  const mappedParams = reduce(Object.keys(filteredParams), (acc, key) => {
    const {name, type, translateValueKey} = validQueryParams.find(
      ({ translateParamKey }) => t(get(messages, translateParamKey)) === key
    );

    let value;
    if (translateValueKey) {
      const paramsTranslations = get(messages, translateValueKey, {});
      // This only works if the message key matches with the param value that we need to send to the API
      value = get(Object.entries(paramsTranslations).find(([, item]) => t(item) === filteredParams[key]),'[0]');
    }
    else {
      value = filteredParams[key];
    }

    return { ...acc, [name]: type === 'number' ? Number(value) : value };
  }, {});

  return pickBy(mappedParams, value => value || !isNaN(value));
};

export const getPartySearchUrl = (params = {}) => {
  const validQueryParams = getPartySearchValidParams().filter(({ query }) => query);
  const filteredQueryParams = omitBy( // omits params matching default value specified in config
    pick(params, validQueryParams.map(({ name }) => name)), // picks only the values which are valid query string
    (value, key) => validQueryParams.find(({ name }) => name === key).default === value
  );
  const mappedParams = reduce(filteredQueryParams, (acc, value, key) => {
    const param = validQueryParams.find(({ name }) => name === key);
    const translatedName = t(get(messages, param.translateParamKey));
    const translatedValue = (param.translateValueKey) ?
      t(get(messages, `${param.translateValueKey}.${value}`)) :
      value;
    return { ...acc, [translatedName]: translatedValue };
  }, {});

  const uri = stringify(mappedParams);
  const suffix = `${uri ? '?' : ''}${uri}`;
  return `${rts().PARTY_SEARCH_URL_ROOT}${suffix}`;
};
